// en, de, fr, pt
export default {
    en: {},
    de: {},
    fr: {},
    pt: {},
};
